// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, anyOf, maybe, objectOf } from "@altostra/type-validations";
import { any, boolean, number, string } from "@altostra/type-validations/lib/primitives";

const catalogFieldToken = anyOf(string, number);

const importErrorEntry = objectOf({
  id: string,
  value: maybe(any),
});

const updateErrorEntry = objectOf({
  id: maybe(string),
  row: maybe(number),
  value: maybe(any),
});

export const isAppsBusinessAccountsResult = objectOf({
  accounts: arrayOf(
    objectOf({
      description: string,
      fields: arrayOf(
        objectOf({
          name: string,
          token: catalogFieldToken,
          type: string,
          is_optional: maybe(boolean),
          is_required: maybe(boolean),
        })
      ),
      name: string,
      num_items: number,
      storage_size: number,
      updated_at: maybe(string, true),
      created_at: maybe(string, true),
      id: string,
      import_errors: arrayOf(importErrorEntry),
      processing: boolean,
      update_error: updateErrorEntry,
    })
  ),
});
